import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function Loyalty() {
  const [cfg, setCfg] = useState({ points_per_rupee: 0, redemption_value_per_point: 0, min_bill_for_earning: 0, min_points_for_redeem: 100 });

  useEffect(() => { api.get("/loyalty/config").then((r) => setCfg(r.data)); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.put("/loyalty/config", cfg); toast.success("Saved"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-6 max-w-2xl" data-testid="loyalty-page">
      <Card className="rounded-sm p-6 border-slate-200">
        <h2 className="text-xl font-bold tracking-tight mb-1" style={{ fontFamily: "Cabinet Grotesk, IBM Plex Sans, sans-serif" }}>Loyalty Program</h2>
        <p className="text-sm text-slate-500 mb-6">Configure how customers earn and redeem points.</p>
        <form onSubmit={submit} className="grid grid-cols-2 gap-4">
          <div><Label>Points earned per ₹</Label><Input type="number" step="0.01" value={cfg.points_per_rupee} onChange={(e) => setCfg({ ...cfg, points_per_rupee: parseFloat(e.target.value) || 0 })} className="rounded-none mt-1" data-testid="loyalty-ppr" /></div>
          <div><Label>₹ per point on redemption</Label><Input type="number" step="0.01" value={cfg.redemption_value_per_point} onChange={(e) => setCfg({ ...cfg, redemption_value_per_point: parseFloat(e.target.value) || 0 })} className="rounded-none mt-1" data-testid="loyalty-rvp" /></div>
          <div><Label>Minimum bill for earning (₹)</Label><Input type="number" step="0.01" value={cfg.min_bill_for_earning} onChange={(e) => setCfg({ ...cfg, min_bill_for_earning: parseFloat(e.target.value) || 0 })} className="rounded-none mt-1" /></div>
          <div><Label>Minimum points for redemption</Label><Input type="number" value={cfg.min_points_for_redeem} onChange={(e) => setCfg({ ...cfg, min_points_for_redeem: parseInt(e.target.value) || 0 })} className="rounded-none mt-1" /></div>
          <div className="col-span-2"><Button type="submit" className="bg-slate-900 hover:bg-slate-800 rounded-none" data-testid="loyalty-save">Save Configuration</Button></div>
        </form>
      </Card>
    </div>
  );
}
